import { LocationViewChoices } from '@/constants/enum';
import { IListLocation } from '@/types/components/location';
import type { TabProps } from '@shopify/polaris';
import { IndexFilters, IndexFiltersMode, useSetIndexFiltersMode } from '@shopify/polaris';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

type TFiltersLocation = {
  queryValue: string;
  setQueryValue: React.Dispatch<React.SetStateAction<string>>;
  selectedView: number;
  handleSelectedView: (index: number) => void;
  handleChangeValueFilter: (value: string) => void;
  onSortColumn: () => void;
  listLocations: IListLocation[];
};

const FilterTableLocations = ({
  queryValue,
  setQueryValue,
  selectedView,
  handleSelectedView,
  handleChangeValueFilter,
  onSortColumn,
  listLocations,
}: TFiltersLocation) => {
  const { t } = useTranslation('locations');
  const { mode, setMode } = useSetIndexFiltersMode();

  const onHandleCancel = () => {
    handleChangeValueFilter('');
  };

  const itemStrings = useMemo(() => {
    return [`${t('tableLocation.status')}`, `${t('tableLocation.pickupSettings')}`, `${t('tableLocation.deliverySettings')}`];
  }, [t]);

  const tabs: TabProps[] = itemStrings.map((item, index) => ({
    content: item,
    index,
    onAction: () => {
      handleSelectedView(index);
    },
    id: `${item}-${index}`,
    isLocked: index === 0,
  }));

  return (
    <div>
      <IndexFilters
        queryValue={queryValue}
        queryPlaceholder={`Search by store name, location address${
          selectedView === LocationViewChoices.DELIVERY ? ', zone name' : ''
        }`}
        onQueryChange={handleChangeValueFilter}
        onQueryBlur={() => setQueryValue(queryValue.trim())}
        onQueryClear={() => handleChangeValueFilter('')}
        filters={[]}
        selected={selectedView}
        onSelect={handleSelectedView}
        appliedFilters={[]}
        onClearAll={() => handleChangeValueFilter('')}
        cancelAction={{
          onAction: onHandleCancel,
        }}
        canCreateNewView={false}
        tabs={tabs}
        mode={mode}
        setMode={setMode}
        showEditColumnsButton={listLocations.length > 1}
        onEditStart={(mode) => {
          if (mode === IndexFiltersMode.EditingColumns) {
            setMode(IndexFiltersMode.Default);
            onSortColumn();
          }
        }}
      />
    </div>
  );
};

export default FilterTableLocations;
